<script>
	export default {
		props: {
			data: {
				type: Object,
				required: true
			},
			errorForm: {
				type: Boolean,
				required: true
			}
		},	
		data() {
			return {
				date_attrs: [
					{
						key: 'today',
						highlight: {
							color: 'gray',
							fillMode: 'light',
						},
						dates: new Date()
					},	
				],
				modelConfig: {
                    type: 'string',
                    mask: 'YYYY-MM-DD'
                }
			}
		},
		watch: {
			"data.value": {
				handler(value) {
					if(value) this.data.error = false;
					else this.data.error = true;
				},
				deep: true,
			}
		}
	}
</script>
<template>
	<div>
		<label class="form-label text-secondary">
			{{ data.label }}
		</label>

		<v-date-picker 
			color="blue"
			title-position="left"
			:available-dates='{ start: null, end: new Date() }'
			:attributes='date_attrs'
			v-model="data.value"
			:model-config="modelConfig"
		>
			<template #default="{ inputValue, inputEvents }">
				<input 
					:value="inputValue" 
					v-on="inputEvents" 
					type="text"
					class="form-control input-custom"
					:class="{'is-invalid': data.error  && errorForm }"
					placeholder="00/00/0000"
				/>
				<div class="invalid-feedback">
					Debes agregar una fecha
				</div>
			</template>
		</v-date-picker>
	</div>
</template>